import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const ghost = defineConnector({
  identifier: "ghost",
  name: "Ghost",
  tagLine: "Publishing platform",
  logo,
  protocol: "http",
  tags: ["documents"],
  defaultUrlPattern: ({ url }) => domainToRegex(url),
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Content API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your Ghost admin panel, go to **Settings → Integrations** and create a custom integration to get your Content API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "baseUrl",
          label: "Ghost URL",
          required: true,
          target: { kind: "configuration", field: "url" },
          placeholder: "https://your-site.ghost.io",
        },
        {
          kind: "input",
          label: "Content API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ url }) =>
      `${url}/ghost/api/v3/content/settings/?key=placeholder`,
  },
});
